<div class="container">

  <!-- 🎟️ INVITADOS -->
  <div class="card">
    <h2>Invitados</h2>

    <table>
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Menú</th>
          <th>Fecha</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let inv of invitados">
          <td>{{ inv.nombre }}</td>
          <td>{{ inv.menu }}</td>
          <td>
            {{ inv.fecha }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>


  <!-- 💌 MENSAJES -->
  <div class="card">
    <h2>Mensajes</h2>

    <table>
      <thead>
        <tr>
          <th>Mensaje</th>
          <th>Fecha</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let msg of mensajes">
          <td>{{ msg.mensaje }}</td>
          <td>
            {{ msg.fecha?.toDate() | date:'dd/MM/yyyy HH:mm' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>